export const WINDOW_SPEC_THREAT_LIST = 'PARENT_WINDOW_SPEC';

export function setWindowSpecThreatList(windowSpecThreatList: $TSFixMe) {
  return {
    type: WINDOW_SPEC_THREAT_LIST,
    windowSpecThreatList,
  };
}
